import React from "react";
import "./Template_1.css";

const Template_1_AboutUs = () => {
  return (
    <section id="about" className="Template_1 section">
      <div className="Template_1 container">
        <div className="Template_1 section-title">
          <h2>About Us</h2>
          <p>Learn more about our story and what makes us different</p>
        </div>
        <div className="Template_1 about-content">
          <div className="Template_1 about-text">
            <h3>Your Trusted Travel Partner</h3>
            <p>
              TravelEase was founded in 2010 with a simple mission: to make
              extraordinary travel experiences accessible to everyone. Over the
              years, we've helped thousands of travelers discover the world's
              most beautiful destinations.
            </p>
            <p>
              Our team of travel experts carefully curates each package,
              ensuring that every detail is taken care of. From luxury resorts
              to adventurous expeditions, we offer a wide range of options to
              suit every traveler's preferences.
            </p>

            <div className="Template_1 about-stats">
              <div className="Template_1 stat">
                <div className="Template_1 stat-number">13+</div>
                <div className="Template_1 stat-label">Years Experience</div>
              </div>
              <div className="Template_1 stat">
                <div className="Template_1 stat-number">50+</div>
                <div className="Template_1 stat-label">Destinations</div>
              </div>
              <div className="Template_1 stat">
                <div className="Template_1 stat-number">10k+</div>
                <div className="Template_1 stat-label">Happy Travelers</div>
              </div>
            </div>
          </div>
          <div className="Template_1 about-image">
            <img
              src="https://images.unsplash.com/photo-1531538606174-0f90ff5dce83?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
              alt="Travel Team"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Template_1_AboutUs;
